if (!customElements.get('yr-header-v2')) {
  customElements.define('yr-header-v2', class extends HTMLElement {
    connectedCallback() {
      document.body.classList.add('yr-header-v2-active');
      this.growaveShadowRoots = new WeakSet();
      this.growaveObservers = [];
      this.observeGrowaveRoot(document.documentElement);
      this.growaveScanTimers = [500, 1500, 4000].map((delay) => window.setTimeout(() => {
        this.processGrowaveNode(document.documentElement);
      }, delay));
      this.openButton = this.querySelector('.yr-header-v2__menu-button');
      this.closeButton = this.querySelector('.yr-header-v2__drawer-close');
      this.drawer = this.querySelector('.yr-header-v2__drawer');
      this.overlay = this.querySelector('.yr-header-v2__overlay');
      this.querySelectorAll('[data-language-select]').forEach((select) => {
        select.addEventListener('change', () => select.form?.submit());
      });
      this.announcementSlides = [...this.querySelectorAll('[data-announcement-slide]')];
      this.announcementIndex = 0;
      this.querySelector('[data-announcement-prev]')?.addEventListener('click', () => this.changeAnnouncement(-1));
      this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.changeAnnouncement(1));
      this.querySelector('[data-announcement-close]')?.addEventListener('click', () => {
        window.clearInterval(this.announcementTimer);
        this.querySelector('[data-announcement-bar]')?.remove();
      });
      const announcementBar = this.querySelector('[data-announcement-bar]');
      const autoplaySeconds = Number(announcementBar?.dataset.announcementAutoplay || 0);
      if (this.announcementSlides.length > 1 && autoplaySeconds > 0) {
        this.announcementTimer = window.setInterval(() => this.changeAnnouncement(1), autoplaySeconds * 1000);
        announcementBar.addEventListener('mouseenter', () => window.clearInterval(this.announcementTimer), { once: true });
      }
      this.searchPanel = this.querySelector('[data-header-search-panel]');
      this.searchBackdrop = this.querySelector('[data-header-search-backdrop]');
      this.searchInput = this.querySelector('[data-header-search-input]');
      this.searchResults = this.querySelector('[data-header-search-results]');
      this.searchPopular = this.querySelector('[data-header-search-popular]');
      this.searchPopularList = this.querySelector('[data-header-search-popular-list]');
      this.defaultPopularQueries = [...(this.searchPopularList?.querySelectorAll('[data-search-query]') || [])]
        .map((button) => button.dataset.searchQuery || button.textContent.trim())
        .filter(Boolean);
      this.searchTrigger = this.querySelector('[data-header-search-trigger]');
      this.handleWishlistCount = (event) => this.updateWishlistCount(event.detail?.count);
      window.addEventListener('yr:wishlist-count', this.handleWishlistCount);
      this.updateWishlistCount();
      this.searchTrigger?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.openSearch();
      });
      this.searchTrigger?.querySelector('input')?.addEventListener('focus', () => this.openSearch());
      this.querySelector('[data-header-search-trigger-mobile]')?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.openSearch();
      });
      this.querySelector('[data-header-search-trigger-mobile] input')?.addEventListener('focus', () => this.openSearch());
      this.querySelector('[data-header-search-trigger-mobile-button]')?.addEventListener('click', () => this.openSearch());
      this.querySelector('[data-header-search-close]')?.addEventListener('click', () => this.closeSearch());
      this.searchBackdrop?.addEventListener('click', () => this.closeSearch());
      this.querySelector('[data-header-search-clear]')?.addEventListener('click', () => {
        this.searchInput.value = '';
        this.searchResults.innerHTML = '';
        this.showRandomPopularQueries();
        this.updateSearchLayout();
        this.searchInput.focus();
      });
      this.searchPopularList?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-search-query]');
        if (button) {
          this.searchInput.value = button.dataset.searchQuery || button.textContent.trim();
          this.loadSearchResults();
          this.searchInput.focus();
        }
      });
      this.showRandomPopularQueries();
      this.searchInput?.addEventListener('input', () => {
        window.clearTimeout(this.searchDebounce);
        this.searchDebounce = window.setTimeout(() => this.loadSearchResults(), 250);
      });
      if (!this.openButton || !this.drawer || !this.overlay) return;
      this.openButton.addEventListener('click', () => this.toggle(true));
      this.closeButton?.addEventListener('click', () => this.toggle(false));
      this.overlay.addEventListener('click', () => this.toggle(false));
      this.drawer.addEventListener('click', (event) => {
        const openPanelButton = event.target.closest('[data-drawer-open]');
        const backButton = event.target.closest('[data-drawer-back]');
        if (openPanelButton) this.showDrawerPanel(openPanelButton.dataset.drawerOpen);
        if (backButton) this.showDrawerPanel('main');
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          if (this.searchPanel?.classList.contains('is-open')) this.closeSearch();
          else this.toggle(false);
        }
      });
    }

    disconnectedCallback() {
      window.clearInterval(this.announcementTimer);
      window.clearTimeout(this.searchDebounce);
      this.searchRequest?.abort();
      this.growaveScanTimers?.forEach((timer) => window.clearTimeout(timer));
      this.growaveObservers?.forEach((observer) => observer.disconnect());
      this.growaveObservers = [];
      window.removeEventListener('yr:wishlist-count', this.handleWishlistCount);
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('yr-header-v2-drawer-open');
      document.body.classList.remove('yr-header-v2-active');
    }

    toggle(open) {
      if (open) this.showDrawerPanel('main');
      this.drawer.classList.toggle('is-open', open);
      this.overlay.classList.toggle('is-open', open);
      this.openButton.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('overflow-hidden', open);
      document.body.classList.toggle('yr-header-v2-drawer-open', open);
      if (open) this.closeButton?.focus();
      else this.openButton.focus();
    }

    showDrawerPanel(name) {
      this.drawer?.querySelectorAll('[data-drawer-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.drawerPanel === name);
      });
    }

    changeAnnouncement(direction) {
      if (this.announcementSlides.length < 2) return;
      this.announcementSlides[this.announcementIndex].classList.remove('is-active');
      this.announcementIndex = (this.announcementIndex + direction + this.announcementSlides.length) % this.announcementSlides.length;
      this.announcementSlides[this.announcementIndex].classList.add('is-active');
    }

    openSearch() {
      if (!this.searchPanel || !this.searchInput || !this.searchBackdrop) return;
      const panelForm = this.querySelector('.yr-header-v2__search-panel-form');
      this.updateSearchPosition();
      if (panelForm) {
        panelForm.style.removeProperty('left');
        if (window.innerWidth >= 1024 && this.searchTrigger) {
          const triggerRect = this.searchTrigger.getBoundingClientRect();
          const triggerInputRect = this.searchTrigger.querySelector('input')?.getBoundingClientRect();
          const panelRect = this.searchPanel.getBoundingClientRect();
          panelForm.style.width = `${triggerRect.width}px`;
          if (triggerInputRect) {
            panelForm.style.gridTemplateColumns = `${triggerInputRect.left - triggerRect.left}px minmax(0, 1fr) 42px`;
          }
          this.searchPanel.style.paddingTop = `${Math.max(0, triggerRect.top - panelRect.top)}px`;
          const formRect = panelForm.getBoundingClientRect();
          panelForm.style.left = `${triggerRect.left - formRect.left}px`;
          if (this.searchPopular) {
            const closeRect = panelForm.querySelector('[data-header-search-close]')?.getBoundingClientRect();
            const contentWidth = closeRect ? closeRect.right - triggerRect.left : triggerRect.width;
            this.searchPopular.style.removeProperty('left');
            this.searchPopular.style.width = `${contentWidth}px`;
            const popularRect = this.searchPopular.getBoundingClientRect();
            this.searchPopular.style.left = `${triggerRect.left - popularRect.left}px`;
            if (this.searchResults) {
              this.searchResults.style.width = `${contentWidth}px`;
              this.searchResults.style.left = this.searchPopular.style.left;
            }
          }
        } else {
          panelForm.style.removeProperty('width');
          panelForm.style.removeProperty('grid-template-columns');
          this.searchPanel.style.removeProperty('padding-top');
          this.searchPopular?.style.removeProperty('width');
          this.searchPopular?.style.removeProperty('left');
          this.searchResults?.style.removeProperty('width');
          this.searchResults?.style.removeProperty('left');
        }
      }
      this.searchPanel.classList.add('is-open');
      this.searchBackdrop.classList.add('is-open');
      this.searchPanel.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(() => {
        this.updateSearchLayout();
        this.searchInput.focus();
      });
    }

    closeSearch() {
      if (!this.searchPanel || !this.searchBackdrop) return;
      window.clearTimeout(this.searchDebounce);
      this.searchRequest?.abort();
      this.searchInput.value = '';
      this.searchResults.innerHTML = '';
      this.showRandomPopularQueries();
      this.searchPanel.classList.remove('is-open');
      this.searchBackdrop.classList.remove('is-open');
      this.searchPanel.setAttribute('aria-hidden', 'true');
      this.searchTrigger?.querySelector('button')?.focus();
    }

    updateSearchPosition() {
      const top = (this.querySelector('[data-announcement-bar]')?.offsetHeight || 0) + (this.querySelector('.yr-header-v2__utility')?.offsetHeight || 0);
      this.searchPanel.style.top = `${top}px`;
    }

    updateSearchLayout() {
      if (!this.searchPanel || !this.searchBackdrop) return;
      this.searchBackdrop.style.top = `${this.searchPanel.offsetTop + this.searchPanel.offsetHeight}px`;
    }

    updateWishlistCount(value) {
      const wishlistCounts = document.querySelectorAll('[data-header-wishlist-count], [data-mobile-wishlist-count]');
      if (!wishlistCounts.length) return;
      let count = Number(value);
      if (!Number.isFinite(count)) {
        try {
          const ids = JSON.parse(window.localStorage.getItem('yrFigmaWishlistProductIds') || '[]');
          count = Array.isArray(ids) ? ids.length : 0;
        } catch (_error) {
          count = 0;
        }
      }
      const nextValue = String(Math.max(0, count));
      const shouldHide = count < 1;
      wishlistCounts.forEach((wishlistCount) => {
        if (wishlistCount.textContent !== nextValue) wishlistCount.textContent = nextValue;
        wishlistCount.classList.toggle('is-hidden', shouldHide);
      });
    }

    observeGrowaveRoot(root) {
      if (!root || this.growaveShadowRoots.has(root)) return;
      this.growaveShadowRoots.add(root);
      this.processGrowaveNode(root);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => this.processGrowaveNode(node)));
      });
      observer.observe(root, { childList: true, subtree: true });
      this.growaveObservers.push(observer);
    }

    processGrowaveNode(node) {
      if (!node || (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.DOCUMENT_FRAGMENT_NODE)) return;
      if (node.matches?.('.gw-wl-drawer-button-wrapper, .gw-rv-drawer-button-wrapper')) {
        node.style.setProperty('display', 'none', 'important');
      }
      node.querySelectorAll?.('.gw-wl-drawer-button-wrapper, .gw-rv-drawer-button-wrapper').forEach((button) => {
        button.style.setProperty('display', 'none', 'important');
      });
      if (node.shadowRoot) this.observeGrowaveRoot(node.shadowRoot);
      node.querySelectorAll?.('*').forEach((element) => {
        if (element.shadowRoot) this.observeGrowaveRoot(element.shadowRoot);
      });
    }

    showRandomPopularQueries() {
      const queries = [...this.defaultPopularQueries];
      for (let index = queries.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [queries[index], queries[randomIndex]] = [queries[randomIndex], queries[index]];
      }
      this.renderPopularQueries(queries.slice(0, 5));
    }

    renderPopularQueries(queries, highlight = '') {
      if (!this.searchPopularList) return;
      this.searchPopularList.innerHTML = '';
      queries.slice(0, 5).forEach((query) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.searchQuery = query;
        const matchIndex = highlight ? query.toLocaleLowerCase().indexOf(highlight.toLocaleLowerCase()) : -1;
        if (matchIndex < 0) {
          button.textContent = query;
        } else {
          button.append(document.createTextNode(query.slice(0, matchIndex)));
          const mark = document.createElement('mark');
          mark.textContent = query.slice(matchIndex, matchIndex + highlight.length);
          button.append(mark, document.createTextNode(query.slice(matchIndex + highlight.length)));
        }
        this.searchPopularList.append(button);
      });
    }

    async loadSearchResults() {
      const query = this.searchInput?.value.trim() || '';
      if (!query) {
        this.searchResults.innerHTML = '';
        this.showRandomPopularQueries();
        this.updateSearchLayout();
        return;
      }
      this.searchRequest?.abort();
      this.searchRequest = new AbortController();
      const root = window.Shopify?.routes?.root || '/';
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,query',
        'resources[limit]': '5',
        'resources[options][unavailable_products]': 'last',
        section_id: 'yr-header-search-results',
      });
      try {
        const response = await fetch(`${root}search/suggest?${params.toString()}`, { signal: this.searchRequest.signal });
        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-search-results-content]');
        const suggestedQueries = [...doc.querySelectorAll('[data-search-query-results] [data-search-query]')]
          .map((button) => button.dataset.searchQuery || button.textContent.trim())
          .filter(Boolean);
        const normalizedQuery = query.toLocaleLowerCase();
        const fallbackQueries = this.defaultPopularQueries.filter((item) => item.toLocaleLowerCase().includes(normalizedQuery));
        this.renderPopularQueries(suggestedQueries.length ? suggestedQueries : fallbackQueries, query);
        this.searchResults.innerHTML = content ? content.outerHTML : '';
        this.updateSearchLayout();
      } catch (error) {
        if (error.name !== 'AbortError') this.searchResults.innerHTML = '<p class="yr-header-search-results__empty">Не удалось загрузить результаты поиска</p>';
        this.updateSearchLayout();
      }
    }
  });
}
